<div
    class="vc-chart-wrapper-container"
    [class.vc-form-container]="formContainer"
    [style.height]="contentHeight"
    [vcProgressSpinner]="loading">
    @if (showHeader) {
        <div class="vc-chart-wrapper-header">
            @if (title) {
                <h2 class="vc-chart-wrapper-title h3-heading">{{ title }}</h2>
            } @else {
                <ng-content select="[chartActionsTitle]"></ng-content>
            }
            <ng-content select="[chartActionsRightSide]"></ng-content>
        </div>
    }
    <ng-content></ng-content>
</div>
